import { apply } from "core/utils";
import { displayError } from "core/utils/modals";
import useOnce from "hooks/use-once";
import { useState } from "react";
import usePathNavigate from "../../../../../hooks/use-path-navigate";
import { ActionHandler } from "../../../../../types";
import { buscarPagosPendientes as apiBuscarPagosPendientes } from "../../api/pagos.api";
import PagosPendientesTable from "../../components/pagos-pendientes.table";
import { PagoPendienteRespuesta } from "../../types/pagos.types";

const usePagosPendientes = () => {
	const [registros, setRegistros] = useState<PagoPendienteRespuesta[]>([]);
	const [cargandoDatos, setCargandoDatos] = useState(false);
	const navigate = usePathNavigate();

	const buscarPagos = () => {
		setCargandoDatos(true);
		setRegistros([]);

		apiBuscarPagosPendientes()
			.then(setRegistros)
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const pagar = (registro: PagoPendienteRespuesta) => {
		navigate("/:segmento/pagos/individual", { state: [registro] });
	};

	useOnce(() => {
		buscarPagos();
	});

	return {
		cargandoDatos,
		registros,
		pagar
	};
};

type PagosPendientesViewProps = {
	onSelectionChanged?: ActionHandler<PagoPendienteRespuesta[]>;
};

const PagosPendientesView = ({ onSelectionChanged }: PagosPendientesViewProps) => {
	const {
		registros,
		pagar
	} = usePagosPendientes();

	return (
		<PagosPendientesTable
			pagar={pagar}
			registros={registros}
			onSelectionChanged={onSelectionChanged}
		/>
	);
};

export default PagosPendientesView;